module.exports = __webpack_public_path__ + "static/media/frodo.9b49d35e.png";